export const money = (n) =>
  new Intl.NumberFormat("fr-CA", { style: "currency", currency: "CAD" }).format(Number(n) || 0);

export const dateFr = (s) => {
  if (!s) return "—";
  const iso = s.length > 10 ? s : s + "T00:00:00";
  const d = new Date(iso);
  if (isNaN(d)) return s;
  return d.toLocaleDateString("fr-CA", { year: "numeric", month: "short", day: "numeric" });
};

export function computeTotals(items) {
  let subtotal = 0;
  let taxable = 0;
  (items || []).forEach((it) => {
    const a = (Number(it.quantity) || 0) * (Number(it.unit_price) || 0);
    subtotal += a;
    if (it.taxable !== false) taxable += a;
  });
  const tps = taxable * 0.05;
  const tvq = taxable * 0.09975;
  return { subtotal, tps, tvq, total: subtotal + tps + tvq };
}

export const QSTATUS = {
  draft: { label: "Brouillon", cls: "bg-muted text-muted-foreground border-border" },
  sent: { label: "Envoyée", cls: "bg-blue-50 text-blue-800 border-blue-200" },
  accepted: { label: "Acceptée", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  declined: { label: "Refusée", cls: "bg-red-50 text-red-700 border-red-200" },
  converted: { label: "Convertie", cls: "bg-violet-50 text-violet-800 border-violet-200" },
};

export const CSTATUS = {
  draft: { label: "Brouillon", cls: "bg-muted text-muted-foreground border-border" },
  sent: { label: "Envoyé", cls: "bg-blue-50 text-blue-800 border-blue-200" },
  active: { label: "Actif", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  terminated: { label: "Résilié", cls: "bg-red-50 text-red-700 border-red-200" },
  expired: { label: "Expiré", cls: "bg-amber-50 text-amber-800 border-amber-200" },
};

export const monthLabel = (ym) => {
  if (!ym) return "";
  const [y, m] = ym.split("-").map(Number);
  const names = ["", "Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
  return `${names[m]} ${y}`;
};

export const STATUS = {
  draft: { label: "Brouillon", cls: "bg-muted text-muted-foreground border-border" },
  sent: { label: "Envoyée", cls: "bg-blue-50 text-blue-800 border-blue-200" },
  paid: { label: "Payée", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  overdue: { label: "En retard", cls: "bg-red-50 text-red-700 border-red-200" },
  cancelled: { label: "Annulée", cls: "bg-muted text-muted-foreground border-border line-through" },
};
